__turbopack_context__.v({
  "bottom-animation-gap": "verifyEmailAddress-module-scss-module__Nju7hq__bottom-animation-gap",
  "button": "verifyEmailAddress-module-scss-module__Nju7hq__button",
  "button-aligned-container": "verifyEmailAddress-module-scss-module__Nju7hq__button-aligned-container",
  "content": "verifyEmailAddress-module-scss-module__Nju7hq__content",
  "gap": "verifyEmailAddress-module-scss-module__Nju7hq__gap",
  "header": "verifyEmailAddress-module-scss-module__Nju7hq__header",
  "instruction": "verifyEmailAddress-module-scss-module__Nju7hq__instruction",
  "label": "verifyEmailAddress-module-scss-module__Nju7hq__label",
  "status": "verifyEmailAddress-module-scss-module__Nju7hq__status",
});
